import { axiosInstance } from '../../../api/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import APIEndpoints from '../../../Admin/api/APIEndpoints';

export const GetAppConfigs = createAsyncThunk(
  'getAppConfigs',
  async (params, { getState }) => {
    const response = await axiosInstance.get(APIEndpoints.getAppConfigs());
    return response.data;
  },
);

export const GetAppDefinations = createAsyncThunk(
  'getAppDefinations',
  async (params, { getState }) => {
    const response = await axiosInstance.get(APIEndpoints.getAppDefinations());
    return response.data;
  },
);

export const GetCustomNetworkList = createAsyncThunk(
  'getCustomNetworkList',
  async (params, { getState }) => {
    const response = await axiosInstance.get(
      APIEndpoints.getCustomNetworkList(),
    );
    return response.data;
  },
);

export const GetReportConfigs = createAsyncThunk(
  'getReportConfigs',
  async (params, { getState }) => {
    const response = await axiosInstance.get(APIEndpoints.getReportConfigs());
    return response.data;
  },
);
